import { css } from '@emotion/react';
import { ListItem, Stack, styled } from '@mui/material';

import HessenLogo from '@/assets/logos/hessen.svg';
import IvmLogo from '@/assets/logos/ivm.png';
import { SectionWrapper } from '@/components/SectionWrapper';
import { BASE_LINKS } from '@/components/const/navigation';
import { StyledLink } from '@/components/navigations/StyledLink';
import { StyledList } from '@/components/navigations/StyledList';
import { useScreenSize } from '@/hooks/useScreenSize';
import { MAIN_BREAKPOINT } from '@/modules/MAIN_BREAKPOINT';
import { useManagementLinks } from '@/utils/navigationLinks';

const Root = styled(SectionWrapper)(
  () => css`
    display: flex;
    position: relative;
  `,
);

const LogoWrapper = styled(Stack)(
  ({ theme }) => css`
    display: none;
    gap: ${theme.spacing(3)};

    ${theme.breakpoints.up(MAIN_BREAKPOINT)} {
      display: flex;
      flex-direction: row;
    }
  `,
);

const ListWrapper = styled(Stack)(
  ({ theme }) => css`
    display: flex;
    width: 100%;
    align-items: center;

    ${theme.breakpoints.up(MAIN_BREAKPOINT)} {
      align-items: flex-end;
    }
  `,
);

interface FooterProps {
  onSelect?: () => void;
  variant?: 'desktop' | 'drawer';
}

export function Footer({ onSelect, variant = 'desktop' }: FooterProps) {
  const { isDesktop } = useScreenSize();
  const managementLinks = useManagementLinks();

  return (
    <Root
      as="footer"
      sx={{
        display: variant === 'desktop' ? { xs: 'none', [MAIN_BREAKPOINT]: 'flex' } : 'flex',
      }}
    >
      <LogoWrapper
        sx={{
          display: { sm: 'none', lg: 'flex' },
        }}
      >
        <img alt="Hessen-Logo" src={HessenLogo} style={{ height: '40px' }} />
        <img alt="Ivm-Logo" src={IvmLogo} style={{ height: '40px' }} />
      </LogoWrapper>

      <ListWrapper>
        <StyledList role="menubar">
          {(isDesktop ? BASE_LINKS : [...managementLinks, ...BASE_LINKS]).map(({ title, link }) => (
            <ListItem key={title} role="none" sx={{ p: 0 }}>
              <StyledLink {...link} onClick={() => onSelect?.()} role="menuitem">
                {title}
              </StyledLink>
            </ListItem>
          ))}
        </StyledList>
      </ListWrapper>
    </Root>
  );
}
